import { Injectable } from '@angular/core';
import { SUBSCRIBE_ENDPOINT } from '@app/shared/constants/form-endpoints.constant';
import { ApiService } from '@app/shared/services/api.service';

@Injectable({
  providedIn: 'root'
})
export class BasicLayoutService {

  constructor(public apiSvc: ApiService) { }

  sendSubscribe(email: string) {
    return this.apiSvc.post(SUBSCRIBE_ENDPOINT, { email });
  }
}
